import styled from "styled-components";

import { LegendBullet } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { percentageSignFilter } from "app/filters/ngFilters";
import { useTranslation } from "pro-features/components/WithTranslation";

const valueFormatter = percentageSignFilter();

const LegendItem = styled(Flex)`
    display: inline-flex;
    [data-automation="legend-item"] {
        margin-right: 0;
    }
`;

type LegendBulletsItemsProps = {
    colorSet: string[];
    values: number[];
};

export const GenderDistributionComparisonLegendBulletItems = ({ colorSet, values }: LegendBulletsItemsProps) => {
    const t = useTranslation();

    return (
        <Flex gap="16px">
            <LegendItem
                gap="8px"
                justifyContent="flex-end"
            >
                <LegendBullet
                    labelColor={colorSet[0]}
                    text={t("category.demographics.gender.chart.legend.male")}
                />
                <Text fontVariant="body2">{valueFormatter(values[0], 1)}</Text>
            </LegendItem>
            <LegendItem
                gap="8px"
                justifyContent="flex-end"
            >
                <LegendBullet
                    labelColor={colorSet[1]}
                    text={t("category.demographics.gender.chart.legend.female")}
                />
                <Text fontVariant="body2">{valueFormatter(values[1], 1)}</Text>
            </LegendItem>
        </Flex>
    );
};
